// const productionEnv = process.env.DB_ENV === 'production';
const baseUrl = "https://api.pairplay.gg";
// const baseUrl = "http://localhost:9000"
//  : "http://localhost:9000";

export default baseUrl;